//#region import libraries
import React, { useEffect, useState } from 'react';

// custom components
import { NewScreen, Title as CustomTitle } from "_atoms";

// bootstrap
import { Row, Col, Button, Modal } from 'react-bootstrap';


// scenes
import MarketplaceList from '../marketplace-list';
import CreateProduct from '../create-product';
import ProductInformation from '../product-information';
import RetailerForm from '_components/organisms/marketplace/retailer-form';
//redux
import { useDispatch, useSelector } from 'react-redux';
import { selectUserDb } from '_redux/slices/main-screen/user';
import { reset as resetTransactions } from "_redux/slices/marketplace/transaction"
import { getAirportRetailers, selectAirportRetailerStatus, selectRetailers, resetRetailerStatus, getRetailer } from '_redux/slices/marketplace/retailer';

// tremor
import { Flex } from '@tremor/react';

//#endregion

const Marketplace = () => {

    //#region redux
    const dispatch = useDispatch()
    const dbUser = useSelector(selectUserDb);
    const airportRetailersStatus = useSelector(selectAirportRetailerStatus)
    const retailers = useSelector(selectRetailers);
    //testing

    //#endregion

    // states
    const [tab, setTab] = useState(1);
    const [ableToAddProduct, setAbleToAddProduct] = useState(true)
    //#region useEffect


    useEffect(() => {
        dispatch(resetRetailerStatus())
        dispatch(resetTransactions())
        setTab(1)
    }, [])


    // CHECK IF THERE ARE RETAILERS FOR AIRPORT BEFORE ADD NEW PRODUC
    useEffect(() => {
        if (airportRetailersStatus === "succeeded") {

            if (retailers.length) {
                setAbleToAddProduct(true);
                setTab(2)

            } else setAbleToAddProduct(false);
        }

    }, [airportRetailersStatus])


    //#region functions
    // information includes transactions of product, so Is there any additional screen for it
    const createdProduct = () => {
        // a product has been successfully created, navigate to its information page

        setTab(1)
    }

    const verifyAbilityToAdd = () => {
        if (dbUser && dbUser.details?.type === "AIRPORT") {
            dispatch(getAirportRetailers(dbUser.details.authority))
            setTab(2)
        }
        if (dbUser && dbUser.role === "RETAILER") {
            dispatch(getRetailer(dbUser.firebaseId))
            setTab(2)
        }
    }
    // PREVENT ANY UNEXPECTED BEHAVIOR 
    const handleCloseModal = () => {
        setAbleToAddProduct(true)
        setTab(1)
        dispatch(resetRetailerStatus())
    }

    //#endregion

    return (
        <NewScreen >
            <Row>
                <Col>

                    {/* Titles */}
                    <Row>
                        <Col>
                            <CustomTitle subtitle={"Marketplace"} description={"List items on the PRM Mobile Marketplace"} />
                        </Col>
                    </Row>

                    {/* Tab Switcher */}
                    <Row >
                        {tab == 1 &&
                            <Flex>
                                <Button onClick={verifyAbilityToAdd}>Create Marketplace Listing</Button>
                                {dbUser && dbUser.role !== "RETAILER" &&
                                    <Button onClick={() => { setTab(4) }}>Create Retailer</Button>
                                }
                            </Flex>
                        }
                    </Row>

                    {/* view list of products*/}
                    {tab == 1 && <MarketplaceList selectedProduct={() => { setTab(3) }} />}
                    {/* create new product*/}
                    {tab == 2 && <CreateProduct createdProduct={createdProduct} back={() => { setTab(1) }} />}
                    {/* view product information*/}
                    {tab == 3 && <ProductInformation back={() => { setTab(1) }} />}
                    {/*create retiler*/}
                    {tab == 4 && <RetailerForm submitted={() => { setTab(1) }} />}

                </Col>
            </Row>

            {!ableToAddProduct &&
                <Modal show={!ableToAddProduct} onHide={handleCloseModal}>
                    {/* Header */}
                    <Modal.Header closeButton>
                        <Modal.Title>Adding Product</Modal.Title>
                    </Modal.Header>

                    {/* Body */}
                    <Modal.Body>You must add a Trailer before create a Marketplace List</Modal.Body>

                    {/* Footer */}
                    <Modal.Footer>
                        {/* Other prop Button */}
                        <Button variant='outline-primary' onClick={() => { [setAbleToAddProduct(true), setTab(4)] }}>Add Trailer</Button>
                        <Button variant='outline-success' onClick={handleCloseModal}>Cancel</Button>
                    </Modal.Footer>
                </Modal>}
        </NewScreen>
    );
}

export default Marketplace;